
































































import { Component, Vue } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as imageLinks from "@/config/image-links";
import { getLocaleStringFromDateString, differenceInDaysBetweenDates, smartDisplayDays } from "@/utils/date-helpers";
import { teamUrl } from "@/utils/url-helpers";


/**
 * Components
 */
import StatCard from "@/components/admin/components/StatCard.vue";

/**
 * API
 */
import adminAPI from "@/api/admin";
import { normalizeString } from "@/utils/string-helpers";
import { GetAllTeamsResponse } from "@/api/admin/get-all-teams.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * Types
 */


/**
 * VueX Modules
 */


type DisplayedTeam = GetAllTeamsResponse.Team & { isActive: boolean };

/**
 * Admin teams list page.
 */
@Component({
	components: {
		DataFetcher,
		StatCard
	}
})
export default class TeamsListPage extends Vue {
	/// Injections
	classes = classes;
	getLocaleStringFromDateString = getLocaleStringFromDateString;
	differenceInDaysBetweenDates = differenceInDaysBetweenDates;
	smartDisplayDays = smartDisplayDays;

	teamUrl = teamUrl;

	imageLinks = imageLinks;

	/// Attributes
	now = new Date();
	isLoading = false;
	// Filters
	searchField = "";
	// Pagination
	page = 1;
	pageCount = 0;
	// Table
	teams: GetAllTeamsResponse.Team[] | null = null;

	get headers() {
		return [
			{
				text: "",
				value: "guildSide",
				align: "center"
			},
			{
				text: this.$t("team.name"),
				value: "name",
				align: "left"
			},
			{
				text: this.$t("team.nb_characters"),
				value: "nbCharacters",
				align: "left"
			},
			{
				text: this.$t("team.nb_rosters"),
				value: "nbRosters",
				align: "left"
			},
			{
				text: this.$t("team.upcoming_events"),
				value: "eventsToCome",
				align: "left"
			},
			{
				text: this.$t("team.last_visit"),
				value: "lastVisit",
				align: "left"
			},
			{
				text: this.$t("team.created_at"),
				value: "createdAt",
				align: "left"
			},
			{
				text: this.$t("team.premium_level"),
				value: "premiumLevel",
				align: "left"
			}
		];
	}

	get displayedTeams(): DisplayedTeam[] {
		if (this.teams == null) {
			return [];
		}

		const normalizedSearchField = normalizeString(this.searchField);
		return this.teams
			.map(x => ({
				...x,
				isActive:
					x.lastVisit != null
					&& differenceInDaysBetweenDates(new Date(Date.parse(x.lastVisit)), this.now) < 7
					&& x.eventsToCome > 0
					&& x.nbRosters > 0
					&& x.nbCharacters > 0
			}))
			.filter(g =>
				g.name && normalizeString(g.name).includes(normalizedSearchField)
			);
	}

	/// Methods
	async created() {
	}

	async fetch() {
		this.teams = await adminAPI.getTeams();
	}
}
